export const SEGMENT_WRITE_KEY =
  process?.env?.REACT_APP_SEGMENT_WRITE_KEY ||
  "CXF3BdB960lEBDe3RMGU3WECBDKFAtEP";
